/**
 * Pelayan & pengurus's routes (spec 2026-09-30): the directory, the Tambah orang wizard and a
 * person's entry in one lazy chunk under a layout whose crumb is "Pelayan & pengurus"
 * (routes/pelayan/index.tsx says why one chunk). The static "baru" and "kelompok" outrank the id
 * segment in react-router's ranking. Groups are added in the directory now (spec 2026-10-03 per
 * paroki, 6): an old address of the page that held them, `/pelayan/kelompok…`, leads there, by a
 * loader's redirect, with the parish it chose (`?paroki=`) open (`?buka=`). Its own module, so a
 * test matches its addresses without the browser router that app/router builds at import.
 */
import { uiStrings } from '@satu/shared'
import { type LoaderFunctionArgs, redirect } from 'react-router'

/** The old Atur kelompok address: Pelayan & pengurus, its parish open. */
function keDirektori({ request }: Pick<LoaderFunctionArgs, 'request'>): Response {
  const paroki = new URL(request.url).searchParams.get('paroki')
  if (paroki === null || paroki === '') return redirect('/pelayan')
  return redirect(`/pelayan?${new URLSearchParams({ buka: paroki })}`)
}

export const rutePelayan = {
  path: '/pelayan',
  lazy: async () => ({ Component: (await import('../routes/pelayan')).PelayanLayout }),
  handle: { crumb: uiStrings.pelayan.layar.judul },
  children: [
    {
      index: true,
      lazy: async () => ({ Component: (await import('../routes/pelayan')).PelayanRoute }),
    },
    {
      path: 'baru',
      lazy: async () => ({ Component: (await import('../routes/pelayan')).TambahOrangRoute }),
      handle: { crumb: uiStrings.pelayan.wizard.judul },
    },
    { path: 'kelompok/*', loader: keDirektori },
    {
      path: ':id',
      lazy: async () => ({ Component: (await import('../routes/pelayan')).OrangRoute }),
      handle: { crumb: uiStrings.pelayan.orang.remah },
    },
  ],
}
